export default "__VITE_ASSET__845867a0__"